import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "md:pt-36 pt-12 px-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center md:text-48px text-2xl font-inter-bold" }, " Supporters ", -1)
const _hoisted_3 = { class: "md:mt-24 md:mb-24 mt-12 mb-6 justify-between flex-wrap grid-supporters" }

import Container from './Container.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Supporters',
  setup(__props) {

const supporters = [
  {
    src: 'arweave_org'
  },
  {
    src: 'big_brain_holding'
  },
  {
    src: 'digital'
  },
  {
    src: 'dodo'
  },
  {
    src: 'd1'
  },
  {
    src: 'foresight'
  },
  {
    src: 'hash_key'
  },
  {
    src: 'hash_global'
  },
  {
    src: 'loin_glory'
  },
  {
    src: 'mask'
  },
  {
    src: 'okx'
  },
  {
    src: 'seven_x'
  }

]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(supporters, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              style: _normalizeStyle(`background-image: url(${require(`../images/${item.src}.png`)})`),
              class: "flex bg-center md:mb-12 mb-6 bg-contain bg-no-repeat bg-everWhite rounded"
            }, null, 4)
          }), 64))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})